import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-navegacao-servidor',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './navegacao-servidor.component.html',
  styleUrls: ['./navegacao-administrativa.component.css']
})
export class NavegacaoServidorComponent {
  @Input() aba = '';
  @Input() itens: Array<{ id: string; rotulo: string }> = [];
  @Output() selecionar = new EventEmitter<string>();
  @Output() sair = new EventEmitter<void>();
}
